import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { cn } from '@/lib/utils';
import { initialsOf, personHue } from './status';

export interface PersonAvatarProps {
  name: string | null | undefined;
  /** Optional photo URL. */
  src?: string | null;
  /** Pixel size (default 32). */
  size?: number;
  /** Seed for the colour (defaults to name). */
  seed?: string | null;
  className?: string;
  /** Render a dashed placeholder (e.g. the "Unassigned" column). */
  placeholder?: boolean;
}

/** Round avatar with a stable soft hue + initials, or a photo when provided. */
export function PersonAvatar({ name, src, size = 32, seed, className, placeholder }: PersonAvatarProps) {
  const hue = personHue(seed ?? name);
  return (
    <Avatar
      className={cn('shrink-0', className)}
      style={{ width: size, height: size }}
    >
      {src ? <AvatarImage src={src} alt="" /> : null}
      <AvatarFallback
        className={cn('font-semibold', placeholder && 'border border-dashed border-border bg-muted text-muted-foreground')}
        style={
          placeholder
            ? { fontSize: Math.max(10, size * 0.36) }
            : {
                fontSize: Math.max(10, size * 0.36),
                background: `hsl(${hue} 70% 93%)`,
                color: `hsl(${hue} 45% 32%)`,
              }
        }
      >
        {placeholder ? '?' : initialsOf(name)}
      </AvatarFallback>
    </Avatar>
  );
}
